import { createFileRoute } from '@tanstack/react-router';
import { JoinScreen } from '@/components/JoinScreen';

export const Route = createFileRoute('/join')({
  component: () => <JoinScreen />,
});
